import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";

interface IConfig {
	poi: boolean | string;
	author: boolean | string;
	my: boolean | string;
}

interface IType extends IConfig {
	name: string;
	value: string;
}

const EMPTY_TYPE: IConfig = {
	poi: false,
	author: false,
	my: false,
};

const TYPES: Array<IType> = [{
	name: "default",
	value: "default",
	...EMPTY_TYPE,
	poi: true,
}, {
	name: "createDate",
	value: "createDate",
	author: false,
	...EMPTY_TYPE,
	my: true,
}, {
	name: "takeDate",
	value: "takeDate",
	poi: true,
	author: true,
	my: true,
}, {
	name: "view",
	value: "viewCount",
	...EMPTY_TYPE,
	author: true,
	my: true,
}];

const DEFAULT: IConfig = {
	poi: "default",
	author: "takeDate",
	my: "createDate",
};

/**
 * Řazení v galerii
 */
export default class Sorter {
	_list: HTMLUListElement;

	_types: Array<IType>;

	_actualtype: string;

	_items: Array<HTMLElement>;

	_node: HTMLDivElement;

	_galleryType: string;

	_default: IConfig;

	_actual: HTMLSpanElement;

	constructor(actual = "default", galleryType = "poi") {
		this._node = node("div", { className: "sorter" });
		this._items = [];
		this._list = node("ul");
		this._actualtype = actual;
		this._galleryType = galleryType;
		this._actual = null;
		this._types = TYPES.slice();
		this._default = { ...DEFAULT };

		this._types.splice(2, 0, {
			name: "like",
			value: "likeCount",
			poi: true,
			author: true,
			my: true,
		});

		if (Mapy.CUS.userweb?.photoBeautySort) {
			this._types.push({
				name: "beauty",
				value: "beauty",
				...EMPTY_TYPE,
				poi: true,
				author: true,
				my: true,
			});
		}

		this._default.author = "likeCount";

		this._build();
	}

	destroy() {
		this._actualtype = "";
		this._actual = null;
		this._clear();
	}

	get node() {
		return this._node;
	}

	get sort() {
		let state = "";

		if (this._default[this._galleryType] !== this._actualtype) {
			state = this._actualtype;
		}

		return state;
	}

	getDefaultSort(galleryType) {
		return this._default[galleryType] ? this._default[galleryType] : "default";
	}

	setType(type = "default", galleryType) {
		this._actualtype = type;

		if (galleryType) {
			this._galleryType = galleryType;
		}

		this._clear();
		this._build();
	}

	handleEvent(event) {
		if (event.target === this._actual || this._actual.contains(event.target)) {
			this._node.classList.toggle("open");

			Mapy.getComponent("logger").log("click", Object.assign(Mapy.getComponent("gallery").logData, {
				text: this._node.classList.contains("open") ? "sortingShow" : "sortingHide",
			}));
		} else {
			const index = event.target.dataset.index;

			Mapy.getComponent("logger").log("click", Object.assign(Mapy.getComponent("gallery").logData, {
				text: _(`gallery.sorter.${this._types[index].name}`),
			}));

			const customEvent = new CustomEvent("sort", { detail: { index, type: this._types[index].value } });

			this._node.dispatchEvent(customEvent);

			this._node.classList.remove("open");
		}
	}

	_clear() {
		this._items.forEach(item => {
			item.removeEventListener("click", this);
		});
		this._items = [];

		Mapy.Util.clear(this._list);
		Mapy.Util.clear(this._node);
	}

	_build() {
		this._node.innerText = _("gallery.sorter.label");

		this._list.className = "";

		let itemsCount = 0;

		this._types.forEach((sortType, key) => {
			if (sortType[this._galleryType]) {
				const title = sortType.name === "beauty"
					? "Beauty"
					: _(`gallery.sorter.${sortType.name}`);

				if (sortType.value === this._actualtype) {
					const actual = node("span", {}, title);

					actual.appendChild(icon("dropdown"));
					actual.addEventListener("click", this);

					this._items.push(actual);

					this._actual = actual;

					this._node.appendChild(actual);
				} else {
					const item = node("li", {}, title);

					item.setAttribute("data-index", key.toString());
					item.addEventListener("click", this);

					this._items.push(item);

					this._list.appendChild(item);

					itemsCount++;
				}
			}
		});

		this._list.classList.add(`items-${itemsCount}`);

		this._node.appendChild(this._list);
	}
}
